export function mapCustomFields(dataItems, currentBooking, currentNoteAgents) {
    if (!dataItems) return [];
    const bookingNote = currentBooking?.note || [];

    // extract unique custom fields from booking items
    const customFields = dataItems?.map((item) => item.ticketTypeCustomFields).flat(1);
    // deduplicate custom fields by name, type, and description, but keep the one with required=true if any
    const allCustomFields = customFields || [];
    const deduplicatedCustomFields = [];
    allCustomFields.forEach((field) => {
        const existingIndex = deduplicatedCustomFields.findIndex(
            (f) =>
                f.name === field.name &&
                f.type === field.type &&
                // TODO: should check everything? (description, description_i18n and name_i18n)
                JSON.stringify(f.description) === JSON.stringify(field.description),
        );
        if (existingIndex === -1) {
            deduplicatedCustomFields.push(field);
        } else if (field.required && !deduplicatedCustomFields[existingIndex].required) {
            deduplicatedCustomFields[existingIndex] = field;
        }
    });

    const uniqueCustomFieldsMapped = deduplicatedCustomFields.map((e) => {
        // extend with values
        const n = bookingNote.find((note) => note.label === e.name);
        return {
            ...e,
            ticketField: true,
            oldNote: true,
            value: n ? n.value : '',
        };
    });

    // combine unique custom fields with bookingNote fields
    return [
        ...uniqueCustomFieldsMapped,
        ...bookingNote
            // filter out custom fields that are already in bookingNote
            .filter((note) => !uniqueCustomFieldsMapped.some((field) => field.name === note.label))
            // these are the ones added as random notes, so these are the chatty ones
            .map((note) => ({
                user: currentNoteAgents.find((agent) => agent.id === note.user),
                name: note.label,
                type: 'chat',
                value: note.value,
                ticketField: false,
                oldNote: true,
                required: false,
            })),
    ];
}

// The booking `note` array is the persisted shape; the editor works on the
// richer field objects from mapCustomFields. buildNotePayload converts back.
export function buildNotePayload(fields) {
    return fields.map((field) => ({
        label: field.name,
        value: field.value,
        user: field.user ? field.user.id : null,
    }));
}

export function noteKey(fields) {
    return JSON.stringify(buildNotePayload(fields));
}
